import React from 'react';
export function BonusSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-66">
      <div className="max-w-5xl mx-auto" data-id="element-67">
        <div className="text-center mb-6" data-id="element-68">
          <h2 className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-69">
            Además recibís estos BONUS
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-600 mb-4" data-id="element-70"></h3>
          <div className="inline-block bg-red-600 text-white text-xl md:text-2xl font-black px-8 py-3 rounded-full shadow-lg animate-bounce" data-id="element-71">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="space-y-6" data-id="element-72">
          {/* Bonus 1 */}
          <div className="flex flex-col md:flex-row items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-73">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-74">
              <a href="#compra" className="cursor-pointer hover:scale-105 transition-transform" data-id="element-75">
                <img src="https://cdn.magicpatterns.com/uploads/quSjPBELDQS5K4qcZ5MzgT/6a8f4675-667c-48fe-b82c-49f4d933885e.png" alt="Glosas Listas" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-76" />
              </a>
            </div>
            <div className="w-full md:w-1/2" data-id="element-77">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-78">
                🎁 BONUS 1 – Glosas Listas
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-79">
                Discursos completos para actos escolares durante todo el año.
              </p>
              <p className="text-lg mb-2" data-id="element-80">Incluye glosas desarrolladas para:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-81">
                <li className="flex items-center" data-id="element-82">
                  <span className="text-blue-500 mr-2" data-id="element-83">•</span> inicio de clases
                </li>
                <li className="flex items-center" data-id="element-84">
                  <span className="text-blue-500 mr-2" data-id="element-85">•</span> fechas patrias
                </li>
                <li className="flex items-center" data-id="element-86">
                  <span className="text-blue-500 mr-2" data-id="element-87">•</span> actos escolares
                </li>
                <li className="flex items-center" data-id="element-88">
                  <span className="text-blue-500 mr-2" data-id="element-89">•</span> cierre de ciclo
                </li>
                <li className="flex items-center" data-id="element-90">
                  <span className="text-blue-500 mr-2" data-id="element-91">•</span> entrega de
                  diplomas
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-92">
                Discursos pensados para emocionar, reflexionar y acompañar cada
                acto escolar.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-93">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-94">
              <a href="#compra" className="cursor-pointer hover:scale-105 transition-transform" data-id="element-95">
                <img src="https://cdn.magicpatterns.com/uploads/vH88y7PoJXM5zR8iYEF95o/4cc8ccb0-28dc-4c8a-b425-ccbe06d414ae.png" alt="Actos Resueltos" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-96" />
              </a>
            </div>
            <div className="w-full md:w-1/2" data-id="element-97">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-98">
                🎁 BONUS 2 – Actos Resueltos
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-99">
                Organizá los actos escolares sin empezar desde cero.
              </p>
              <p className="text-lg mb-2" data-id="element-100">Incluye:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-101">
                <li className="flex items-center" data-id="element-102">
                  <span className="text-blue-500 mr-2" data-id="element-103">•</span> estructura
                  completa de actos escolares
                </li>
                <li className="flex items-center" data-id="element-104">
                  <span className="text-blue-500 mr-2" data-id="element-105">•</span> orden de
                  participación
                </li>
                <li className="flex items-center" data-id="element-106">
                  <span className="text-blue-500 mr-2" data-id="element-107">•</span> ideas para
                  conducir actos
                </li>
                <li className="flex items-center" data-id="element-108">
                  <span className="text-blue-500 mr-2" data-id="element-109">•</span> organización de
                  ceremonias escolares
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-110">
                Un material que te permite organizar actos escolares de forma
                rápida y clara.
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="flex flex-col md:flex-row items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-111">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-112">
              <a href="#compra" className="cursor-pointer hover:scale-105 transition-transform" data-id="element-113">
                <img src="https://cdn.magicpatterns.com/uploads/sLTrEExPsYGMJZfGLwEgaQ/443e7edd-d3c4-408d-9ff1-bb6e23a20f4f.png" alt="Pack Mundial" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-114" />
              </a>
            </div>
            <div className="w-full md:w-1/2" data-id="element-115">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-116">
                🎁 BONUS 3 – Pack Mundial
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-117">
                Actividades listas para trabajar el Mundial 2026 en clase o en
                casa.
              </p>
              <p className="text-lg mb-2" data-id="element-118">Incluye:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-119">
                <li className="flex items-center" data-id="element-120">
                  <span className="mr-2" data-id="element-121">⚽</span> fichas educativas
                </li>
                <li className="flex items-center" data-id="element-122">
                  <span className="mr-2" data-id="element-123">⚽</span> sopas de letras
                </li>
                <li className="flex items-center" data-id="element-124">
                  <span className="mr-2" data-id="element-125">⚽</span> juegos temáticos
                </li>
                <li className="flex items-center" data-id="element-126">
                  <span className="mr-2" data-id="element-127">⚽</span> actividades del Mundial
                </li>
                <li className="flex items-center" data-id="element-128">
                  <span className="mr-2" data-id="element-129">⚽</span> propuestas educativas para el
                  aula
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-130">
                Ideal para aprovechar el Mundial como recurso educativo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}